

























































































import { Vue, Component } from "../vue-ext";
import { HousingCompany, InstallationInfo } from "../models";

@Component
export default class HousingCompanyInfoView extends Vue {
    private housingCompany: HousingCompany | null = null;
    private installation: InstallationInfo | null = null;

    private async created() {
        this.root.setTitle(this.$t("menu.housingCompanyInfo") as string);
        this.root.setIconClass("icon-taloyhtio");
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;
        this.installation = await this.root.service.housingCompany.GetInstallationInfo(this.housingCompany.housingCompanyId) as InstallationInfo;
    }
}
